exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".kv-ve-spacer__inner[data-v-933d4c54] {\n  width: 100%;\n  background: repeating-linear-gradient(90deg, rgba(148, 163, 184, 0.15), rgba(148, 163, 184, 0.15) 10px, rgba(148, 163, 184, 0.05) 10px, rgba(148, 163, 184, 0.05) 20px);\n  border-radius: 8px;\n}\n", ""]);

// exports
